import { IContainerConfigSide } from "../types/IContainerConfigSide";
import { IContainerType } from "../types/IContainerType";

export function getLogoName(
  carrierName: string,
  containerType: IContainerType,
  position: IContainerConfigSide,
  format: "png" | "jpg",
): string {
  return `${carrierName}-${containerType}-${position}.${format}`;
}
